import { useQuery } from '@tanstack/react-query';
import { ApiResponseCheckIfFavorited } from '../../types/business/businessCompany';
import { businessCompanyRequest } from '../../business/BusinessCompanyRequest';
import { queryKeys } from '../../constants/queryKeys';
import { IdBasedHookOptions } from './types';

function useCheckIfCompanyFavorited({
  id,
  enabled = true,
}: IdBasedHookOptions) {
  const QUERY_KEY = [queryKeys.businessCompanyIsFavorited, id];

  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => businessCompanyRequest.checkIfFavorited(id),
    select: (data: ApiResponseCheckIfFavorited) => data.isFavorited,
    enabled: Boolean(id) && enabled,
  });
}

export default useCheckIfCompanyFavorited;
